module.exports = __webpack_public_path__ + "media/country_flags/sn-bd85e95d.png";